"use client";
import cn from "clsx";
import { useState, useLayoutEffect, useInsertionEffect, JSX } from "react";
import * as Select from "@radix-ui/react-select";
import { Flex, Skeleton } from "@radix-ui/themes";
//import { CircleHalf, Sun, Moon, Spinner, Icon as IconType } from "@phosphor-icons/react";

import Icon from "@/components/common/icon/icon";
import { AppPostData } from "@/util/apputil";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

const data: {
  [key: string]: {
    label: string;
    icon: JSX.Element; //IconType;
    //iconName: string;
  };
} = {
  system: { label: "Auto", icon: <Icon iconType="" iconName="CircleHalf" /> },
  light: { label: "Light", icon: <Icon iconType="" iconName="Sun" /> },
  dark: { label: "Dark", icon: <Icon iconType="" iconName="Moon" /> },
};
const defaultTheme = "light";
function changeTheme(value: string, isSet: boolean): string {
  if (typeof window !== "undefined") {
    const storage: string = (window.localStorage.getItem("theme") ?? "").trim();
    if (isSet && storage != value) {
      window.localStorage.setItem("theme", value);
      AppPostData({ dataType: "setLocalStorage", key: "theme", value });
      const e = new StorageEvent("storage", {
        storageArea: window.localStorage,
        key: "theme",
        oldValue: storage,
        newValue: value,
        url: window.location.href,
      });
      window.dispatchEvent(e);
    }
    return storage;
  } else {
    return "";
  }
}

export default function ThemeButton({ className, themeType }: { className?: string; themeType?: string }) {
  const themeCheck = themeType ?? defaultTheme;
  const [loading, setLoading] = useState<boolean>(true);
  const [value, setValue] = useState<string>(() => {
    const temp = typeof window !== "undefined" ? (window.localStorage.getItem("theme") ?? themeCheck) : themeCheck;
    if (data[temp] != null) {
      return temp;
    } else {
      if (typeof window !== "undefined") {
        window.localStorage.setItem("theme", defaultTheme);
        return defaultTheme;
      }
      return defaultTheme;
    }
  });

  //값이 변경될때
  useInsertionEffect(() => {
    const theme: string = (window.localStorage.getItem("theme") ?? defaultTheme).trim();
    //document.documentElement.classList.add("theme_" + theme);
  }, []);

  useLayoutEffect(() => {
    setLoading(false);
  }, [value]);

  const valueChange = (value: string) => {
    setValue(value);
    changeTheme(value, true);
  };

  return (
    <Flex direction="column" className={cn(className, loading ? " loading" : " ", value)}>
      <Select.Root value={value} onValueChange={valueChange} name="tool_theme_button_select">
        <Select.Trigger className="outline-0" id="tool_theme_button" aria-label="Tool Theme Button">
          <Flex id="themeState" align="center" gap="2" className="p-1">
            <Select.Icon className={cn(loading ? "animate-spin" : "", "SelectIcon")}>
              <Icon iconType="" iconName="Spinner" className={cn(loading ? "block" : "hidden", "w-5 h-5 ")} />
              <Icon
                iconType=""
                iconName="Sun"
                className={cn(
                  !loading && value == "light" ? "block" : "hidden",
                  "w-5 h-5 hover:animate-wiggle-more hover:animate-infinite",
                )}
              />
              <Icon
                iconType=""
                iconName="Moon"
                className={cn(!loading && value == "dark" ? "block" : "hidden", "w-5 h-5 hover:animate-wiggle-more hover:animate-infinite")}
              />
              <Icon
                iconType=""
                iconName="CircleHalf"
                className={cn(!loading && value == "system" ? "block" : "hidden", "w-5 h-5 hover:animate-jump hover:animate-infinite")}
              />
            </Select.Icon>
          </Flex>
        </Select.Trigger>
        <Select.Content position="popper" id="">
          <Select.Item value="light" className={cn(value == "light" ? "hidden" : "", "cursor-pointer mt-1 p-1 outline-amber-500 group")}>
            <Icon iconType="" iconName="Sun" className="block w-5 h-5 hover:animate-wiggle-more hover:animate-infinite" />
          </Select.Item>
          <Select.Item value="dark" className={cn(value == "dark" ? "hidden" : "", "cursor-pointer mt-1 p-1 outline-amber-500 group")}>
            <Icon iconType="" iconName="Moon" className="block w-5 h-5 group-hover:animate-wiggle-more group-hover:animate-infinite" />
          </Select.Item>
          <Select.Item value="system" className={cn(value == "system" ? "hidden" : "", "cursor-pointer mt-1 p-1 outline-amber-500 group")}>
            <Icon iconType="" iconName="CircleHalf" className="block w-5 h-5 group-hover:animate-jump group-hover:animate-infinite" />
          </Select.Item>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
